const persianNums = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];

export function toPersian(word: string): string {
  const id = persianNums;
  return word.replace(/[0-9]/g, (w) => {
    return id[+w];
  });
}

export const toEnglish = (str: string): string => {
  for (let i = 0; i < 10; i++) {
    str = str
      .replace(persianNumbers[i], i.toString())
      .replace(arabicNumbers[i], i.toString());
  }
  return str;
};

export const normalizeArabic = (text: string): string => {
  return text.replace("ي", "ی");
};

/*
Arvano-Authorization header
`token` param could be a password as well!
WARN don't use it when it's not necessary (do it and get 403 hahaha)
*/
export const toAuth = (userName: string, token: string) =>
  window.btoa(`${userName}:${token}`);
